






























































































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Route, NavigationGuardNext } from 'vue-router';

import * as firebase from "firebase/app";

import { Agency } from "@/scripts/datatypes";
import { firestore } from "@/scripts/firebase";

import json from "../../../private/agencies.json";

import AdminButtons from "@/components/AdminButtons.vue";
import Admin from "@/mixins/Admin.vue";

Component.registerHooks(["beforeRouteEnter"]);

@Component({ components: { AdminButtons }, mixins: [Admin]})
export default class Agencies extends Vue {
  agencies: Array<Agency> = [];
  columns = [
    {
      field: "type",
      label: "Type",
      searchable: true,
      sortable: true,
    },
    {
      field: "organization",
      label: "Organization",
      searchable: true,
      sortable: true,
    }
  ];
  checkedRows = [];
  openedDetailed = [];
  detacher?: firebase.Unsubscribe;

  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext) {
    next(vm => {
      if (
        vm.$store.state.user.uid != "EhJwGIUSFzOdVMvpoNigKgdc91n1" &&
        vm.$store.state.user.uid != "tceYfMwHleZkP5ErLzgeB8rygeY2"
      ) {
        next({ path: "/" });
      }
    });
  }

  async created() {
    this.detacher = this.refAgencies.onSnapshot(
      (snapshot: firebase.firestore.QuerySnapshot) => {
        this.agencies = snapshot.docs.map(doc => {
          return Object.assign(doc.data(), { id: doc.id }) as Agency;
        });
      }
    );
  }
  destroyed() {
    this.detacher && this.detacher();
  }

  get refAgencies(): firebase.firestore.Query {
    return firestore()
      .collection("agencies")
      .orderBy("timeCreated");
  }

  get hasUser(): boolean {
    return !!this.$store.state.user;
  }

  get contactInformation(): string {
    const contactInformation = this.checkedRows
    .map((r: Agency) => {
      let info = "";
      if (r.type == "city" || r.type == "county") {
        info += `${r.organization} ${r.attention}\n`;
      } else { // fire_district
        info += `${r.organization}`;
        info += (r.attention ?? "") == "" ? "" : `Attn: ${r.attention}\n`;
      }

      info += (r.building ?? "") == "" ? "" : `${r.building}\n`;
      info += (r.address1 ?? "") == "" ? "" : `${r.address1}\n`;
      info += (r.pobox ?? "") == "" ? "" : `${r.pobox}\n`;
      info += (r.address2 ?? "") == "" ? "" : `${r.address2}\n`;
      info += (r.email ?? "") == "" ? "" : `${r.email}\n`;

      return info;
    })
    .join("\n");

    return contactInformation;
  }

  handleDelete() {
    // https://firebase.google.com/docs/firestore/manage-data/delete-data#node.js_2
    console.log("handleDelete() is called.");

    const agencies = firestore().collection("agencies");
    agencies
      .get()
      .then(snapshot => {
        // When there are no documents left, we are done
        if (snapshot.size === 0) {
          return 0;
        }

        // Delete documents in a batch
        const batch = firestore().batch();
        snapshot.docs.forEach(doc => {
          batch.delete(doc.ref);
        });

        return batch.commit().then(() => {
          return snapshot.size;
        });
      })
      .then(numDeleted => {
        if (numDeleted === 0) {
          // resolve();
          return;
        }

        // Recurse on the next process tick, to avoid
        // exploding the stack.
        // process.nextTick(() => {
        //   // deleteQueryBatch(db, query, resolve, reject);
        //   handleDelete();
        // });
      })
      .catch();
    // .catch(reject);
  }

  handleRefresh() {
    console.log("handleRefresh() is called.");

    const agencies = firestore().collection("agencies");

    json.forEach(a => {
      agencies.add({
        type: a.type,
        organization: a.organization,
        attention: a.attention ?? "",
        building: a.building ?? "",
        address1: a.address1 ?? "",
        pobox: a.pobox ?? "",
        address2: a.address2 ?? "",
        phone: a.phone ?? "",
        email: a.email ?? "",
        timeCreated: firestore.FieldValue.serverTimestamp()
      });
      console.log(a, " is added.");
    });

    // persons.add({ organization: "Ada County", officer: "Clerk", name: "test" });
  }

  toggle(row: Agency) {
    (this.$refs.table as Vue & { toggleDetails: (row: Agency) => void }).toggleDetails(row)
  }

  copy(element: string) {
    navigator.clipboard.writeText(element);
    this.$buefy.notification.open({
      duration: 1000,
      message: `"${element}" is copied into your clipboard!`,
      position: "is-bottom-right",
      type: "is-info",
      hasIcon: true
    });
  }

  copyContactInformation() {
    navigator.clipboard.writeText(this.contactInformation);
    this.$buefy.notification.open({
      duration: 3000,
      message: `Contact Information is copied into your clipboard!`,
      position: "is-bottom-right",
      type: "is-info",
      hasIcon: true
    });
  }
}
